import React, { FunctionComponent } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  Avatar,
  CardContent,
  CardMedia,
  Chip,
  Divider
} from '@mui/material';

import {
  Typography
} from '../../../components/v2/styled';
import { CardBase } from './Base';

import { User } from '../../../models/User';

import HelpersLanguage from '../../../actions/helpers/language';

type Props = {
  coach: User;
  sx?: any;
  withPractice?: boolean;
  withRole?: boolean;
  extraActions?: any;
};

export const CardCoach: FunctionComponent<Props> = ({coach, sx, withPractice, withRole, extraActions}) => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  return (<CardBase sx={{...sx}}>
    <CardMedia
      sx={{
        height: 100,
        backgroundPositionY: '40%',
        backgroundColor: (!!(coach.settings || {}).is_background_colour ? (!!(coach.settings || {}).background_colour ? (coach.settings || {}).background_colour : 'rgba(0, 0, 0, 0.2)') : 'transparent')
      }}
      image={!(coach.settings || {}).is_background_colour ? coach.get_bg_medium : undefined}
      title={`${coach.first_name} ${coach.last_name}`}
    />
    <CardContent style={{marginTop: '-100px', marginBottom: 'auto'}}>
      <Avatar sx={{width: 100, height: 100}} src={coach.get_medium} />

      <Typography sx={{color: theme.palette.tertiary?.main, marginTop: 1}}>{coach.first_name}</Typography>
      <Typography sx={{color: theme.palette.tertiary?.main, fontSize: '0.75rem'}} variant="body2">{coach.last_name}</Typography>

      {!!withPractice && !!coach.practice?.name && <Typography sx={{color: theme.palette.primary?.main, marginTop: 1}}>{coach.practice?.name}</Typography>}

      {!!withRole && !!coach.is_super && <Chip
        color="primary"
        size="small"
        variant="outlined"
        label="Super"
        sx={{
          marginRight: 0.5,
          marginBottom: 0.5,
          marginTop: 0.5
        }}
      />}
      {!!withRole && !!coach.is_secretary && <Chip
        color="primary"
        size="small"
        variant="outlined"
        label="Secretary"
        sx={{
          marginRight: 0.5,
          marginBottom: 0.5,
          marginTop: 0.5
        }}
      />}

      {(coach.coach_skills || []).length > 0 && <>
        <Divider sx={{marginTop: 1, marginBottom: 1}} />

        <Typography sx={{color: theme.palette.primary.main, fontStyle: 'italic', fontSize: '0.75rem'}}>{t("client.models.coaches.skills", "Skills")}</Typography>
        {(coach.coach_skills || []).map(skill => <Chip
          color="primary"
          size="small"
          variant="outlined"
          label={(
            skill?.name_en && i18n.resolvedLanguage === 'en' ? skill?.name_en : (
              skill?.name_fr && i18n.resolvedLanguage === 'fr' ? skill?.name_fr : (
                skill?.name_de && i18n.resolvedLanguage === 'de' ? skill?.name_de : (
                  skill.name
                )
              )
            )
          ) || skill.name}
          sx={{
            marginRight: 0.5,
            marginBottom: 0.5,
            marginTop: 0.5
          }}
        />)}
      </>}

      {(!!coach.profile_text || !!coach.full_profile_text) && <>
        <Divider sx={{marginTop: 1, marginBottom: 1}} />
      </>}
      {!!coach.profile_text && <>
        <Typography html>{coach.get_profile_text}</Typography>
      </>}
      {!!coach.full_profile_text && <>
        <Typography html>{coach.full_profile_text[HelpersLanguage.mapping_to_id(i18n.resolvedLanguage || 'nl')]}</Typography>
      </>}

      {!!extraActions && extraActions}
    </CardContent>
  </CardBase>);
}